<template>
  <!-- 进度看板 -->
  <div class="progressBoard">
    <!-- 头部 -->
    <div class="head">
      <!-- 项目区域 -->
      <div class="projectRegion">
        <span>项目区域：</span>
        <div class="regions">
          <el-button type="primary" size="mini" :plain="region !== ''" @click="region = ''">全部</el-button>
          <el-button v-for="item in cityRegions" :key="item.code" type="primary" size="mini"
            :plain="region !== item.code" @click="region = item.code">
            {{ item.name }}
          </el-button>

          <div v-if="!regionOpen && prjAreaList.length > 6" class="Btn" @click="regionOpen = true">
            <span>展开</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <div v-if="regionOpen" class="Btn" @click="regionOpen = false">
            <span>收起</span>
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
      </div>
      <!-- 项目时间 -->
      <div class="projectDate">
        <span>项目时间：</span>
        <el-date-picker v-model="projectDate" :picker-options="pickerOptions" type="daterange" size="small" align="right"
          start-placeholder="开始月份" range-separator="至" end-placeholder="结束月份" unlink-panels>
        </el-date-picker>

        <el-button size="small" style="margin-left: 20px;" plain @click="projectDate = ''">重置</el-button>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
    </div>

    <!-- 项目计划看板 -->
    <div class="title">
      <div class="title_left">
        <el-divider direction="vertical"></el-divider>
        <span>项目计划进度</span>
      </div>
      <div class="title_right">
        <span>所属项目：</span>
        <el-select v-model="project" size="small" clearable filterable placeholder="全部" @change="openProgress = 0">
          <el-option v-for="item in taskProgress" :key="item.prjId" :label="item.prjName" :value="item.prjId">
          </el-option>
        </el-select>
        <span>是否有暂停：</span>
        <el-select v-model="isSuspend" size="small" clearable filterable placeholder="全部" @change="search">
          <el-option v-for="item in isSuspendList" :key="item.lable" :label="item.lable" :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- 进度展示板 -->
    <div class="board">
      <!-- 折叠面板 -->
      <el-collapse v-model="openProgress">
        <el-collapse-item v-for="prj,index in projects" :key="prj.prjId" class="taskProgress" :name="index">
          <template slot="title">
            <div class="prjTitle">
              <span>{{ prj.prjName }}</span>
              <div class="nowProgress">当前进度：</div>
              <el-progress :percentage="toDigital(prj.currentProgress)" style="width: 220px" :stroke-width="8"
                color="#0ABB87">
              </el-progress>
              <img :src="jump" style="width: 18px;height: 15px;" @click="toProjectTaskList(prj)">
            </div>
          </template>
          <template slot="header">
            <div class="prjTitle">
              <span>{{ prj.prjName }}</span>
              <div class="nowProgress">当前进度：</div>
              <el-progress :percentage="toDigital(prj.currentProgress)" style="width: 220px" :stroke-width="8"
                color="#0ABB87">
              </el-progress>
            </div>
          </template>
          <!-- 节点行 -->
          <div class="nodes">
            <div class="tabNode">
              <div class="tabRing">
                <div class="greyLine"></div>
              </div>
              <el-tag size="small">计划完成时间</el-tag><br>
              <el-tag size="small" type="success">实际完成时间</el-tag>
            </div>

            <div v-for="item in prj.taskList" :key="item.taskId" class="node">
              <div class="node_name">{{ item.taskName }}</div>
              <div class="ring">
                <div class="greyLine"></div>
                <img :src="ringSrc(item.isSuspend,item.taskStatus)">
                <div class="greyLine"></div>
              </div>
              <div class="planDate">{{ item.endDate }}</div>
              <div class="actualDate">{{ timeFormat(item.realEndDate) }}</div>
            </div>

            <div class="tabNode">
              <div class="tabRing">
                <div class="greyLine"></div>
              </div>
              <div style="height: 60px"></div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dataBoardService from "@/CommonDP/service/dataBoard-service.js";
import Cookies from "js-cookie";
import { storage } from "@/CommonDP/utils";
import moment from "moment";

export default {
  inject: ["reload"],
  components: {},
  data() {
    return {
      ring_grey: require("@/CommonDP/assets/projectMg/dataBoard/ring_grey.png"), // 未开始——圆环图标
      ring_blue: require("@/CommonDP/assets/projectMg/dataBoard/ring_blue.png"), // 进行中——圆环图标
      ring_green: require("@/CommonDP/assets/projectMg/dataBoard/ring_green.png"), // 已完成——圆环图标
      ring_red: require("@/CommonDP/assets/projectMg/dataBoard/ring_red.png"), // 已延期——圆环图标
      ring_orange: require("@/CommonDP/assets/projectMg/dataBoard/ring_orange.png"), // 暂停—圆环图标
      prjAreaList: [], // 项目区域数据

      region: "", // 项目区域
      regionOpen: false, // 项目区域展开
      projectDate: "", // 选择项目时间

      taskProgress: [], // 计划进程
      openProgress: 0,
      project: "", // 所属项目

      pickerOptions: {
        // 日期选择快捷键
        shortcuts: [
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      jump: require("@/CommonDP/assets/projectMg/dataBoard/jump.png"),
      isSuspend: null,
      isSuspendList: [
        {
          lable: '不限',
          value: null
        },
        {
          lable: '否',
          value: 0
        },
        {
          lable: '是',
          value: 1
        }
      ]
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    // 开始时间
    startDate() {
      if (this.projectDate && this.projectDate.length > 0) {
        return moment(this.projectDate[0]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },
    // 结束时间
    endDate() {
      if (this.projectDate && this.projectDate.length > 1) {
        return moment(this.projectDate[1]).format("YYYY-MM-DD") + " 00:00:00";
      } else {
        return "";
      }
    },

    // 城市区域
    cityRegions() {
      let provinces = this.prjAreaList;
      provinces = provinces.filter((item) => item.name);
      provinces = provinces.map((item) => {
        const city = { ...item };
        let name = item.name;
        name = name.replace("市", "");
        city.name = name;
        return city;
      });
      if (!this.regionOpen && this.prjAreaList.length > 6) {
        return provinces.slice(0, 6);
      } else {
        return provinces;
      }
    },

    // 展示项目
    projects() {
      if (this.project) {
        return this.taskProgress.filter((item) => item.prjId === this.project);
      } else {
        return this.taskProgress;
      }
    }
  },
  watch: {
    region() {
      this.$nextTick(() => {
        this.search();
      });
    }
  },
  mounted() {
    this.getPrjAreaList();
    this.getTaskProgress();
  },
  methods: {
    // 圆环图标
    ringSrc(isSuspend, ringSrc) {
      if (isSuspend === 0) {
        switch (ringSrc) {
          case 0:
            return this.ring_grey;
          case 1:
            return this.ring_green;
          case 2:
            return this.ring_blue;
          case 3:
            return this.ring_red;
        }
      } else {
        return this.ring_orange;
      }
    },
    // 阶段比例转成数字
    toDigital(currentProgress) {
      return currentProgress.slice(0, -1) - "0";
    },
    // 实际完成时间展示规范
    timeFormat(time) {
      if (time) {
        return moment(time, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    // 查询项目区域+区域内项目数量
    async getPrjAreaList() {
      const params = {
        enterpriseId: this.enterpriseId
      };
      const res = await dataBoardService.getPrjAreaList(params);
      this.prjAreaList = res.data;
    },
    // 项目计划看板数据
    async getTaskProgress() {
      const params = {
        isSuspend: this.isSuspend,
        enterpriseId: this.enterpriseId,
        cityCode: this.region || "", // 	城市编码
        startDate: this.startDate, // 开始时间
        endDate: this.endDate // 结束时间
      };
      const res = await dataBoardService.getTaskProgress(params);
      this.taskProgress = res.data;
    },
    // 查询
    search() {
      this.getTaskProgress();
    },

    // 导出PPT
    async exportPPT() {
      if (!this.projects.length) {
        this.$message.warning("项目进度为空，没有可以导出的数据");
        return;
      }
      const params = {
        dashboard: 4, // 进度看板固定 4
        condition: {
          enterpriseId: this.enterpriseId,
          cityCode: this.region,
          startDate: this.startDate,
          endDate: this.endDate
        } // 顶部查询条件
      };
      const res = await dataBoardService.exportPPT(params);
      const fileName = "进度看板.pptx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    // 导出excel
    async exportExcel() {
      if (!this.projects.length) {
        this.$message.warning("项目进度为空，没有可以导出的数据");
        return;
      }
      const params = {
        dashboard: 4, // 进度看板固定 4
        condition: {
          enterpriseId: this.enterpriseId,
          cityCode: this.region,
          startDate: this.startDate,
          endDate: this.endDate
        } // 顶部查询条件
      };
      const res = await dataBoardService.exportExcel(params);
      const fileName = "进度看板.xlsx";
      if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(res, fileName);
        return;
      } else {
        const link = document.createElement("a");
        const blob = res;
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", decodeURI(fileName));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    toProjectTaskList(item) {
      const obj = {
        prjId: item.prjId,
        prjName: item.prjName,
        prjCode: item.prjCode
      };
      this.$store.dispatch("updatePrj", obj);
      this.$router.push({ name: "taskList" });
      this.reload();
    }
  }
};
</script>

<style lang='scss' scoped>
.progressBoard {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .head {
    width: 100%;
    padding: var(--big-space);
    border-radius: 0 0 4px 4px;
    background-color: white;
    margin-bottom: var(--middle-space);

    .projectRegion {
      width: 100%;
      display: flex;

      span {
        line-height: 40px;
        font-size: 14px;
        font-weight: 400;
        font-family: "Microsoft YaHei UI";
        color: var(--key-color);
      }

      .regions {
        width: calc(100% - 80px);
        display: flex;
        align-items: center;
        flex-flow: wrap;

        .el-button {
          padding: 7px 18px;
          border: none;
          margin: 5px 0;
          font-family: "PingFang SC";
          font-weight: 400;
          font-size: 14px;
        }

        /deep/ .el-button--primary.is-plain {
          background: #eef3fd !important;
          color: #4777e7 !important;
        }

        .Btn {
          margin-left: 20px;
          white-space: nowrap;
          cursor: pointer;
          display: flex;
          align-items: center;

          span {
            color: var(--theme-color);
            font-family: "PingFang SC";
            font-weight: 400;
            font-size: 14px;
            line-height: 28px;
          }

          i {
            padding: 0 4px;
            color: var(--theme-color);
          }
        }
      }
    }

    .projectDate {
      width: 100%;
      padding: var(--middle-space) 0;
      display: flex;
      align-items: center;

      span {
        font-family: "Microsoft YaHei UI";
        font-weight: 400;
        font-size: 14px;
        line-height: 28px;
        color: var(--key-color);
        white-space: nowrap;
      }
    }
  }

  .title {
    width: 100%;
    padding: var(--small-space) var(--big-space);
    border-bottom: 1px solid #e6eaf8;
    border-radius: 4px 4px 0 0;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title_left {
      display: flex;
      align-items: center;

      .el-divider {
        background-color: var(--theme-color);
        width: 3px;
        height: 15px;
        margin: 0 8px 0 0;
      }

      span {
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        color: var(--key-color);
        white-space: nowrap;
      }
    }

    .title_right {
      display: flex;
      align-items: center;

      span {
        font-family: "Microsoft YaHei UI";
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: var(--common-color);
        white-space: nowrap;
        padding-left: 25px;
      }
    }
  }

  .board {
    width: 100%;
    height: 1px;
    flex-grow: 1;
    overflow: auto;
    padding: var(--big-space);
    border-radius: 0 0 4px 4px;
    background-color: white;

    .taskProgress {
      width: 100%;
      padding-bottom: var(--middle-space);

      .prjTitle {
        width: max-content;
        padding: 9px 11px;
        background-color: rgba(212,217,236,.21);
        display: flex;
        align-items: center;

        span {
          font-size: 14px;
          line-height: 18px;
          font-weight: 400;
          color: var(--key-color);
          white-space: nowrap;
        }

        .nowProgress {
          padding-left: 35px;
          font-size: 14px;
          line-height: 18px;
          color: var(--key-color);
          white-space: nowrap;
        }

        .el-progress {
          display: flex;
          align-items: center;

          /deep/ .el-progress__bar {
            padding: 0;
          }
        }
      }

      .nodes {
        width: 100%;
        padding: 20px 0;
        overflow-x: auto;

        display: flex;
        align-items: center;

        .tabNode {
          width: 90px;
          flex-grow: 1;

          .tabRing {
            width: 100%;
            height: 40px;
            margin-top: 18px;

            display: flex;
            align-items: center;

            .greyLine {
              width: 1px;
              height: 8px;
              flex-grow: 1;
              background: #f2f3f5;
            }
          }

          .el-tag {
            border-radius: 12px;
            margin: 3px 0;
          }
        }

        .node {
          width: calc(16% - 30px);
          min-width: 150px;
          text-align: center;

          .node_name {
            max-width: 100%;
            font-size: 16px;
            line-height: 18px;
            font-weight: 700;
            color: var(--key-color);
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .ring {
            width: 100%;

            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
              margin: 5px;
            }

            .greyLine {
              width: 1px;
              height: 8px;
              flex-grow: 1;
              background: #f2f3f5;
            }
          }

          .planDate {
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            white-space: nowrap;
          }

          .actualDate {
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            white-space: nowrap;
          }
        }
      }
    }
  }
}

.el-collapse {
  border: none !important;

  /deep/ .el-collapse-item__header {
    border: none !important;
    i {
      margin-left: 10px !important;
    }
  }
  /deep/ .el-collapse-item__wrap {
    border: none !important;
  }
  /deep/ .el-collapse-item__content {
    padding: 0;
  }
}
</style>
